
    <div>
      <hr>
      <textarea #dt [value]="text" rows="10" cols="80"></textarea>
      <br/>
      <button (click)="dtextSet()">Show change</button>
    </div>
  